import React, { useMemo } from 'react';
import DENTJaw from '../Jaw/DENTJaw';
import { Mouth } from '../../Interfaces/Mouth.interface';
import { ToothView } from '../../Enums/ToothView.enum';
import { Scale } from '../../../Base/Interfaces/Scale.interface';
import { useDENTContext } from '../../Services/DENTContext';
import { Tooth } from '../../../../graphql/graphql';

export enum MouthView {
	UPPER_JAW = 'upperJaw',
	LOWER_JAW = 'lowerJaw',
	FULL_MOUTH = 'fullMouth',
}

interface Props {
	data: Mouth;
	view: MouthView;
	scale: Scale;
	onToothClick: (tooth: Tooth) => void;
}

const DENTMouth: React.FC<Props> = ({ data, view, scale, onToothClick }) => {
	const { showEndodontic, showPeriodontal } = useDENTContext();

	const { upperView, lowerView } = useMemo(() => {
		switch (view) {
			case MouthView.FULL_MOUTH:
				return {
					upperView: [ToothView.BUCCAL, ToothView.INCISAL],
					lowerView: [ToothView.INCISAL, ToothView.BUCCAL],
				};
			case MouthView.UPPER_JAW:
				return {
					upperView: [ToothView.BUCCAL, ToothView.INCISAL, ToothView.PALATAL],
				};
			case MouthView.LOWER_JAW:
				return {
					lowerView: [ToothView.LINGUAL, ToothView.INCISAL, ToothView.BUCCAL],
				};
		}
	}, [view]);

	const isSingleView = !(upperView && lowerView);
	const showToothPeriodontal = isSingleView && showPeriodontal;
	const showToothEndodontic = !isSingleView && showEndodontic;

	return (
		<div>
			{upperView && (
				<DENTJaw
					data={data.upperJaw}
					views={upperView}
					scale={scale}
					onToothClick={onToothClick}
					showToothPeriodontal={showToothPeriodontal}
					showToothEndodontic={showToothEndodontic}
				/>
			)}
			{lowerView && (
				<DENTJaw
					data={data.lowerJaw}
					views={lowerView}
					reverse={view !== MouthView.LOWER_JAW}
					scale={scale}
					onToothClick={onToothClick}
					showToothPeriodontal={showToothPeriodontal}
					showToothEndodontic={showToothEndodontic}
				/>
			)}
		</div>
	);
};

export default DENTMouth;
